module.exports = __webpack_public_path__ + "img/play.b6e019de.png";